import { render, staticRenderFns } from "./class-schedule.view.vue?vue&type=template&id=2fba2b05&scoped=true&"
import script from "./class-schedule.view.ts?vue&type=script&lang=ts&"
export * from "./class-schedule.view.ts?vue&type=script&lang=ts&"
import style0 from "./class-schedule.view.scss?vue&type=style&index=0&id=2fba2b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba2b05",
  null
  
)

export default component.exports